// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isAnalyticsDashboardAppGroupIdGetCanvasesForFilterResult = arrayOf(
  objectOf({
    name: string,
    id: string,
    status: string,
  })
);
